import { ConnectedForgotPasswordPage } from "controller/auth/connected-forgot-password-page";
import { ConnectedLoginPage } from "controller/auth/connected-login-page";
import { ConnectedResetPasswordPage } from "controller/auth/connected-reset-password-page";
import { ConnectedTokenLoginPage } from "controller/auth/connected-token-login-page";
import React from "react";
import { Route } from "react-router-dom";
import { LogoutView } from "view/auth/logout";

function renderAuthRoutes() {
  return [
    <Route
      exact
      path="/login"
      key="login-view"
      component={ConnectedLoginPage}
    />,
    <Route
      exact
      path="/login/forgot-password"
      key="forgot-password-view"
      component={ConnectedForgotPasswordPage}
    />,
    <Route
      exact
      path="/login/reset-password"
      key="reset-password-view"
      component={ConnectedResetPasswordPage}
    />,
    <Route exact path="/logout" key="logout-view" component={LogoutView} />,
    <Route
      exact
      path="/token-login"
      key="token-login-view"
      component={ConnectedTokenLoginPage}
    />,
  ];
}

export { renderAuthRoutes };
